import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex fixed inset-x-0 top-0 z-30 flex-row items-center py-2 h-10 text-zinc-100 bg-zinc-900 lg:py-4 lg:px-6 lg:h-24" }
const _hoisted_2 = { class: "p-2 mr-4 lg:hidden" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex-none lg:-mt-3 lg:w-auto" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo-tsc.svg",
  class: "w-12 h-8 lg:w-28 lg:h-20",
  alt: "ГЦТИ"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hidden ml-6 text-sm font-bold lg:block" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createTextVNode(" Автономная некоммерческая организация "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" «Государственный центр технических исследований» ")
  ])
], -1)
const _hoisted_7 = { class: "hidden flex-none ml-auto font-bold lg:block" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Об организации ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Политика конфиденциальности ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Контакты ")

import { MenuIcon } from '@heroicons/vue/outline';
import { useStore } from '../stores/main';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const menuOpen = computed(() => {
  return store.menuOpen;
})

function toggleMenu() {
  store.menuOpen = !menuOpen.value
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "",
        onClick: _withModifiers(toggleMenu, ["prevent"])
      }, [
        _createVNode(_unref(MenuIcon), {
          class: _normalizeClass(["w-8 h-8", {'text-teal-300': _unref(store).menuOpen}])
        }, null, 8, ["class"])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_router_link, {
        "active-class": "text-teal-300 cursor-default",
        to: {name: 'page', params: {slug: 'about'}},
        class: "ml-5 hover:text-teal-300"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        "active-class": "text-teal-300 cursor-default",
        to: {name: 'page', params: {slug: 'privacy-policy'}},
        class: "ml-5 hover:text-teal-300"
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        "active-class": "text-teal-300 cursor-default",
        to: {name: 'contacts'},
        class: "ml-5 hover:text-teal-300"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}
}

})